import { render, staticRenderFns } from "./mainContent.vue?vue&type=template&id=2ec1de6f&"
import script from "./mainContent.vue?vue&type=script&lang=js&"
export * from "./mainContent.vue?vue&type=script&lang=js&"
import style0 from "./mainContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports